import { useEffect, useState } from 'react';
import axiosInstance from '../../Services/axiosCommon';

function useFetchMDIndex(url, prop, dependencies = [], shouldFetch = () => true) {
  const [value, setValue] = useState([]);

  function getData() {
    axiosInstance.get(url + prop)
      .then(res => {
        let data = res.data?.data[prop];
        let tempData = [];
        data.forEach((item) => {
          tempData.push({ value: item?.value, label: item?.value });
        });
        if (data) setValue(tempData);
      })
      .catch(err => {
        console.log("err");
      });
  }

  useEffect(() => {
    if (shouldFetch()) {
      getData();
    }
  }, dependencies);

  return { value, getData };
}

export default useFetchMDIndex;
